<template>
  <div class="campaign-preview-option" data-qa="sidebar-language-selector">
    <h3>{{ $t('CampaignForm_Preview_Campaign_Languages') }}</h3>
    <div class="variant-select-ct">
      <el-radio-group
        v-if="getLanguagesList.length <= 4 && model.languages_multi"
        class="radio-group"
        v-model="campaignLanguage"
        @change="onChange"
        data-qa="sidebar-language-radio-group"
      >
        <el-radio
          v-for="language in getLanguagesList"
          :key="language"
          :label="language"
          :data-qa="`sidebar-language-radio-${language}`"
        >
          {{ languagesList[language] }}
        </el-radio>
      </el-radio-group>
      <el-select
        v-else-if="getLanguagesList.length > 4 && model.languages_multi"
        v-model="campaignLanguage"
        @change="onChange"
        data-qa="sidebar-language-select"
      >
        <el-option
          v-for="language in getLanguagesList"
          :key="language"
          :label="languagesList[language]"
          :value="language"
        >
        </el-option>
      </el-select>
      <div v-else data-qa="sidebar-language-static">
        {{ getLanguagesList[0] ? languagesList[getLanguagesList[0]] : '' }}
      </div>
    </div>
  </div>
</template>

<script>
import { languages as languagesList } from '@/modules/campaign-manage/enum/LanguagesEnum'

export default {
  name: 'SidebarLanguageSelector',

  props: {
    model: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      campaignLanguage: this.model.languages_default,
      languagesList
    }
  },

  computed: {
    getLanguagesList() {
      return this.model.languages_list.filter(language => language !== '')
    }
  },

  methods: {
    onChange(languageCode) {
      this.$emit('language-change', languageCode)
    }
  }
}
</script>
<style scoped>
.variant-select-ct {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

h3 {
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: #4b515f;
}

.campaign-preview-option {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 20px;
}

.radio-group {
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-size: 14px;
  line-height: 14px;
  color: #4b515f;
  padding-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/preview/SidebarLanguageSelector.vue